import React from "react";
import { useApp } from "@/context/AppContext";

const scorePw = (p) => {
  let s = 0;
  if (p.length >= 6) s++;
  if (p.length >= 10) s++;
  if (/[A-Z]/.test(p) && /[a-z]/.test(p)) s++;
  if (/\d/.test(p)) s++;
  if (/[^A-Za-z0-9]/.test(p)) s++;
  return Math.max(1, Math.min(s, 4));
};

export function PasswordStrength({ value }) {
  const { t } = useApp();
  if (!value) return null;
  const score = scorePw(value);
  const META = {
    1: { label: t("pwWeak"), color: "#EF4444" },
    2: { label: t("pwMedium"), color: "#F59E0B" },
    3: { label: t("pwGood"), color: "#84CC16" },
    4: { label: t("pwStrong"), color: "#22C55E" },
  };
  const meta = META[score] || META[1];
  return (
    <div data-testid="pw-strength" className="space-y-1">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((i) => (
          <span key={i} className="h-1.5 flex-1 rounded-full transition-colors" style={{ background: i <= score ? meta.color : "#E5E7EB" }} />
        ))}
      </div>
      <p className="text-xs font-body font-medium" style={{ color: meta.color }}>{t("pwStrength")}: {meta.label}</p>
    </div>
  );
}
